import styled from "styled-components";
export const StatusActionContainer = styled.div`
  border: 1px solid ${({theme}) => theme.grayDivider};
  background: ${({theme}) => theme.white};
  border-radius: 8px;
  padding: 34px 30px;

  h1 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.3px;
    text-align: left;
    ${({theme}) => theme.accent};
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.3px;
    text-align: left;
    ${({theme}) => theme.grayDark};
  }

  p:nth-child(2) {
    margin-top: 24px;
    margin-bottom: 30px;
  }
  
  input {
    display: none;
  }
`

export const PreviewEorInvoice = styled.div`
  width: 100%;
  max-width: 300px;
  padding: 10px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background: ${({theme}) => theme.grayBackground};
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    margin-bottom: 24px;
  }

  a {
    color: ${({theme}) => theme.accent};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  svg {
    margin-left: 8px;

    :hover {
      cursor: pointer;
    }
  }
}
`

export const ContractUploader = styled.div`
  display: flex;
  align-items: center;
  a {
    height: auto;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.2px;
    text-align: left;
    color: ${({theme}) => theme.gray};
    transition: all 300ms ease;

    @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
      margin-bottom: 24px;
    }

    svg {
      margin-right: 16px;
    }

    :hover {
      color: ${({theme}) => theme.accent};
      text-decoration: underline;

      svg {
        path {
          fill: ${({theme}) => theme.accent}
        }
      }
    }
  }
`

export const ConcludeRegistration = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-direction: column;
    align-items: start;
  }
`
